import { useState, useEffect } from "react";
import yellowWarningTriangle from "../assets/icons/yellow-warning-triangle.svg";
import redWarningCircle from "../assets/icons/red-warning-circle.svg";

const DiskUsage = ({ usage_percentage, isdiskConnected }) => {
  const [textColor, setTextColor] = useState("text-light-1");
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    if (usage_percentage === 100) {
      setIcon(redWarningCircle);
      setTextColor("text-semantic-red");
    } else if (usage_percentage >= 95) {
      setIcon(yellowWarningTriangle);
      setTextColor("text-yellow-warning");
    } else {
      setIcon(null);
      setTextColor("text-light-1");
    }
  }, [usage_percentage]);

  return (
    <>
      {isdiskConnected && usage_percentage !== null ? (
        <div className="flex items-start">
          <span
            className={`${textColor} text-xxl font-scaniacondensed leading-[64px] `}
          >
            {usage_percentage}
          </span>
          <span
            className={`${textColor} text-xl font-scaniacondensed  pr-[22px]`}
          >
            %
          </span>
          {icon == null ? null : <img src={icon} alt="" />}
        </div>
      ) : (
        <span className="text-light-1 text-xxl font-scaniacondensed leading-[64px]">
          -
        </span>
      )}
    </>
  );
};

export default DiskUsage;
